import React, { FC, useRef, useState } from 'react'
import cn from 'classnames'
import { Arrow } from '../../../Arrow'
import styles from './Select.module.css'
import { useOnClickOutside } from '../../../../hooks/useClickOutside'

type Props = {
  value: string
  onChange?: (value: string) => void
  className?: string
}

export const Select: FC<Props> = ({ className, children, value, onChange }) => {
  const rootRef = useRef(null)
  const [open, setOpen] = useState(false)

  useOnClickOutside(rootRef, () => {
    if (open) {
      setOpen(false)
    }
  })

  const process = (child: JSX.Element) =>
    child.key !== value && (
      <div
        key={child.key}
        className={styles.option}
        onClick={() =>
          onChange && typeof child.key === 'string' && onChange(child.key)
        }
      >
        {child}
      </div>
    )

  let selected =
    Array.isArray(children) &&
    children.find((child: JSX.Element) => child?.key === value)

  if (!selected && Array.isArray(children)) {
    for (const child of children) {
      if (Array.isArray(child)) {
        for (const c of child) {
          if ((c as JSX.Element).key === value) {
            selected = c as JSX.Element
          }
        }
      }
    }
  }

  return (
    <div
      className={cn(styles.root, open && styles.open, className)}
      onClick={() => setOpen(!open)}
      ref={rootRef}
    >
      <div className={styles.selectedOption}>
        {selected} <Arrow className={styles.arrow} />
      </div>
      <div
        className={styles.options}
        style={
          {
            '--options-count':
              Array.isArray(children) &&
              children.reduce<number>(
                (acc, el) => acc + (el && Array.isArray(el) ? el.length : 1),
                0
              ) - 1
          } as React.CSSProperties
        }
      >
        {children &&
          Array.isArray(children) &&
          children.map((child) =>
            Array.isArray(child)
              ? child.map(process)
              : process(child as JSX.Element)
          )}
      </div>
    </div>
  )
}
